"use client";

import FormInputField from "@/components/custom-form/FormInputField";
import PhoneField from "@/components/auth/shared/PhoneField";
import AuthTabs from "@/components/auth/shared/AuthTabs";
import TabPanel from "@/components/auth/shared/TabPanel";
import { useFormContext } from "react-hook-form";
import { IconMail } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";

type ForgotPasswordContentProps = {
  activeTab: "email" | "phone";
  phone: string;
  email: string;
  isSubmitting: boolean;
  errorMessage?: string;
  onTabChange: (value: "email" | "phone") => void;
  onPhoneChange: (value: string) => void;
  onSubmit: (event?: React.BaseSyntheticEvent) => void;
};

const ForgotPasswordContent = ({
  activeTab,
  phone,
  email,
  isSubmitting,
  errorMessage,
  onTabChange,
  onPhoneChange,
  onSubmit,
}: ForgotPasswordContentProps) => {
  const { control, watch } = useFormContext();
  const formEmail = watch("email") ?? email ?? "";
  const formPhone = watch("phone") ?? phone ?? "";
  const rawPhone = formPhone.replace(/\D/g, "");

  const isSendDisabled =
    (activeTab === "phone" && rawPhone.length < 8) ||
    (activeTab === "email" && !formEmail.trim());

  return (
    <div className="mx-auto flex h-full w-full flex-col px-4 md:pb-0 pb-10">
      <AuthTabs value={activeTab} onChange={onTabChange} />

      <div className="flex flex-1 flex-col">
        <form onSubmit={onSubmit} className="flex flex-col gap-3 pb-3 pt-4">
          <div className="relative min-h-[88px] sm:min-h-[92px]">
            <TabPanel active={activeTab === "email"}>
              <FormInputField
                control={control}
                name="email"
                type="email"
                label="Email"
                placeholder="Email"
                leadingIcon={<IconMail className="h-5 w-5" stroke={1.8} />}
              />
            </TabPanel>

            <TabPanel active={activeTab === "phone"}>
              <PhoneField
                value={phone}
                onChange={onPhoneChange}
                errorMessage={activeTab === "phone" ? errorMessage : undefined}
              />
            </TabPanel>
          </div>

          <Button
            type="submit"
            size="xl"
            disabled={isSendDisabled || isSubmitting}
            isLoading={isSubmitting}
            className="mt-2"
          >
            Send Code
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordContent;
